import { Component } from '@angular/core';

import { RcTooltipComponent } from '../rc-tooltip/rc-tooltip.component';
import { IconName } from '@app/shared/utils/icon/icons';

import { TranslatePipe } from '@app/shared/pipes';
import { IconComponent } from '@app/shared/utils/icon/icon.component';

@Component({
  selector: 'app-wlp-tooltip',
  imports: [RcTooltipComponent, TranslatePipe, IconComponent],
  templateUrl: './wlp-tooltip.component.html',
  styleUrls: ['./wlp-tooltip.component.scss'],
})
export class WlpTooltipComponent {
  public readonly IconName = IconName;
}
